import React from 'react';
import { Check } from 'lucide-react';

const PLANS = [
  {
    key: 'starter',
    name: 'Starter',
    price: '$49',
    period: '/month',
    features: [
      '1 agent',
      'Call capture & recording',
      'AI transcription — 40+ languages',
      'SMS & email notifications',
      'Built-in CRM',
    ],
    color: 'var(--blue)',
  },
  {
    key: 'growth',
    name: 'Growth',
    price: '$99',
    period: '/month',
    features: [
      '3 agents',
      'All Starter features',
      'Team routing & round-robin',
      'Agent performance reports',
      'Business hours control',
    ],
    color: 'var(--cyan)',
    popular: true,
  },
  {
    key: 'professional',
    name: 'Professional',
    price: '$199',
    period: '/month',
    features: [
      '10 agents',
      'All Growth features',
      'Simultaneous ring',
      'Advanced analytics',
      '24/7 priority support',
    ],
    color: 'var(--green)',
  },
];

export default function StepPlan({ data, updateData, onNext, onBack, loading, error }) {
  const selectedPlan = PLANS.find(p => p.key === data.plan) || PLANS[0];

  return (
    <div className="ob-card" style={{ maxWidth: 640 }}>
      <h1 className="ob-title">Choose your plan</h1>
      <p className="ob-subtitle">Start free for 14 days. No credit card required.</p>

      <div className="ob-trial-badge">
        🎉 All plans include a 14-day free trial — cancel anytime
      </div>

      <div className="ob-plan-grid">
        {PLANS.map(plan => (
          <div
            key={plan.key}
            className={`ob-plan ${data.plan === plan.key ? 'selected' : ''} ${plan.popular ? 'popular' : ''}`}
            onClick={() => !loading && updateData({ plan: plan.key })}
            style={{
              borderColor: data.plan === plan.key ? plan.color : undefined,
              cursor: loading ? 'not-allowed' : 'pointer',
            }}
          >
            {plan.popular && <div className="ob-plan-badge">Most Popular</div>}
            <div className="ob-plan-name" style={{ color: plan.color }}>{plan.name}</div>
            <div className="ob-plan-price">{plan.price}</div>
            <div className="ob-plan-period">{plan.period}</div>
            {plan.features.map(f => (
              <div key={f} className="ob-plan-feature">
                <Check size={10} color={plan.color} style={{ flexShrink: 0, marginTop: 2 }} />
                {f}
              </div>
            ))}
          </div>
        ))}
      </div>

      <div style={{
        background: 'var(--bg-primary)',
        border: '1px solid var(--border)',
        borderRadius: 8,
        padding: '12px 16px',
        marginBottom: 20,
        fontSize: 13,
        color: 'var(--text-secondary)',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}>
        <span style={{ fontSize: 18 }}>💳</span>
        <span>
          No payment needed today. Your 14-day free trial starts now.
          Add payment details anytime before your trial ends.
        </span>
      </div>

      {error && (
        <div style={{
          background: 'rgba(239,68,68,0.08)',
          border: '1px solid rgba(239,68,68,0.3)',
          borderRadius: 8,
          padding: '10px 14px',
          marginBottom: 16,
          fontSize: 13,
          color: 'var(--red)',
        }}>
          {error}
        </div>
      )}

      <button
        className="ob-btn ob-btn-primary"
        onClick={onNext}
        disabled={loading}
      >
        {loading ? (
          <span style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
            <span className="ob-loading-dot" />
            <span className="ob-loading-dot" />
            <span className="ob-loading-dot" />
            Setting up your account...
          </span>
        ) : (
          `Start free trial with ${selectedPlan.name} →`
        )}
      </button>

      {!loading && (
        <button
          onClick={onBack}
          style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 13, cursor: 'pointer', display: 'block', margin: '12px auto 0' }}
        >
          ← Back
        </button>
      )}
    </div>
  );
}
